import * as moment from 'moment'

export const validRegexId: RegExp = /^[A-Za-z0-9-_/]{4,40}$/
export const validRegexDescription: RegExp = /^[0-9A-Za-zÀ-ÖØ-öø-ÿ-_+: ]+$/
export const validRegexPostalcode: RegExp = /[\w-]+/

// Can't be an object due to zustand state not handling it well
export interface Package {
  computedKey: string
  trackingId: string
  description: string | null
  extraData?: { [index: string]: string }
  id?: string
  collapsed?: boolean
  createdAt: Date
  order?: number | string // string: latest state date, number: drag and drop
  loading?: boolean // loading indicater when fetching carriers info
}

export const createPackage = (
  trackingId: string,
  description: string | null,
  extraData?: { [index: string]: string },
  id?: string,
  collapsed?: boolean
): Package => {
  return {
    computedKey: computedKey(trackingId, extraData),
    trackingId,
    description,
    extraData,
    id,
    collapsed,
    createdAt: moment.utc().toDate(),
  }
}

export function computedKey(trackingId, extraData) {
  let key = `local_${trackingId}`

  if (extraData) {
    for (let param in extraData) {
      key += `_${param}-${extraData[param]}`
    }
  }

  return key.replace(/[\s#.:*!/\\|{}+()&^%$@`~,<>?ˆ´;"']/g, '')
}

export interface PackageDetailsForCreation {
  trackingId: string
  description?: string
  extraData?: object
}
